// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__10q_G","noResultsText":"Section_noResultsText__2Ivq5"};